import { isOrderCollectionDisplay, orderCollectionDisplayRoot } from 'src/config'
import Model from 'src/models/model'

export default ({ router, app }) => {
  if (!isOrderCollectionDisplay) return

  async function quitOrderCollectionDisplay () {
    if (Model.context.currentUser) {
      await Model.context.currentUser.logOut()
    }
    await Model.configuration.validate()
    await Model.context.fetch(true)
    router.replace({ name: 'auth:login' })
  }
  app.config.globalProperties.$quitOrderCollectionDisplay = quitOrderCollectionDisplay
  app.$quitOrderCollectionDisplay = quitOrderCollectionDisplay

  /**
   * Set routes
   */
  const routeData = {
    name: 'order-collection-display:root',
    path: orderCollectionDisplayRoot,
    component: () => import('src/modules/order-collection-display/layouts/OrderCollectionDisplayLayout.vue'),
    beforeEnter: async (_to, _from, next) => {
      await Model.configuration.ensureLoaded()

      // If not logged in, force login
      if (!Model.context.currentUser && !Model.context.currentOrderCollectionDisplayClient) {
        next({ name: 'auth:login' })
        return
      }

      next()
    }
  }

  router.addRoute(routeData)

  if (isOrderCollectionDisplay) {
    router.addRoute({ name: 'app:root', redirect: { name: 'order-collection-display:root' } })
  }
}
